<template>
    <div>
        <v-card flat class="pa-0 ma-0">
            <v-card-text class="text-center">
                <v-avatar v-if="!fototmp" tile style="background: transparent; box-shadow: none;"
                    :width="(!fotoCarnet) ? '100%' : '300px'" :height="(!fotoCarnet) ? '100%' : '300px'">
                    <v-hover v-if="fotoCarnet" v-slot="{ hover }">
                        <v-img :src="`data:image/png;base64,${fotoCarnet}`" class="image-container">
                            <div class="align-self-center">
                                <v-btn :class="{ 'show-btns': hover || $vuetify.breakpoint.smAndDown }"
                                    :color="transparent" icon class="center-btn" @click="eliminarFoto">
                                    <v-icon :class="{ 'show-btns': hover || $vuetify.breakpoint.smAndDown }"
                                        :color="transparent">
                                        mdi-delete
                                    </v-icon>
                                </v-btn>
                            </div>
                        </v-img>
                    </v-hover>
                    <v-img v-else src="@/assets/Instructivo-foto-carnet.png"></v-img>
                    <!--   <v-img v-else src="@/assets/blank-user-profile.png" /> -->
                </v-avatar>
                <v-avatar v-else :size="size" tile>
                    <v-img :src="`data:image/png;base64,${fototmp}`" />
                </v-avatar>
            </v-card-text>
            <v-card-text class="d-flex flex-column justify-center align-center ma-0 pa-0">
                <div v-if="hasWebcam">
                    <v-btn v-if="!fototmp" elevation="0" class="pa-5" width="163px" @click="cambiarPanelFoto"
                        color="primary">
                        <v-icon class="mr-2">mdi-camera-outline</v-icon>
                        TOMAR FOTO
                    </v-btn>
                </div>
                <InputButtonD titulo="seleccionar" icono="mdi-folder-outline" @fotoCargada="fotoSeleccionada"
                    tipo="fotocarnet">
                </InputButtonD>
            </v-card-text>
            <!--         <div v-else-if="$vuetify.breakpoint.mdAndDown">
    <InputButtonD titulo="seleccionar" icono="mdi-folder-outline" @fotoCargada="fotoSeleccionada"
    :tipo="this.tipo">
</InputButtonD>
</div> -->

        </v-card>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import InputButtonD from '@/components/inputs/InputButtonDialogoFoto.vue'
import Camera from '@/components/inputs/CameraCanvas.vue'


export default {
    components: {
        InputButtonD,
        Camera,
    },
    data() {
        return {
            hasWebcam: false,
            image: null,
            showCapture: false,
            imageSrc: '',
            titulo: '',
            icono: '',
            size: '275',

            transparent: 'rgba(255, 255, 255, 0)',
        };
    },
    computed: {
        ...mapGetters('preafiliacion', ['fototmp', 'fotoCarnet']),

    },
    methods: {
        ...mapActions('preafiliacion', ['deleteFotoCarnet', 'precargaFoto']),
        checkWebcam() {
            navigator.mediaDevices.enumerateDevices()
                .then(devices => {
                    devices.forEach(device => {
                        if (device.kind === 'videoinput') {
                            this.hasWebcam = true;
                        }
                    });
                }).catch(error => {
                    console.error('Error enumerating devices:', error);
                });
        },

        descartar() {
            this.precargaFoto('')
        },
        guardar() {
            this.subirFotoPerfil()
            this.showCapture = false
        },
        eliminarFoto() {
            this.deleteFotoCarnet()
        },
        cambiarPanelFoto() {
            this.$emit('abrirCamera')
        },
        fotoSeleccionada() {
            this.$emit('listoCerrar')
        }
    },

    created() {
        if (this.$vuetify.breakpoint.mobile) {
            this.titulo = 'capturar'
            this.icono = 'mdi-camera-outline'
        } else {
            this.titulo = 'subir'
            this.icono = 'mdi-folder-outline'
        }

    },
    mounted() {
        this.checkWebcam()
        if (this.fototmp) {
            this.precargaFoto('')
        }
        this.image = null
        this.showCapture = false
        this.imageSrc = ''

    },
}
</script>
<style>
.image-container {
    position: relative;
    /* Necesario para posicionar elementos hijos */
}

.show-btns {
    color: rgba(255, 255, 255, 1) !important;
}

.center-btn {
    position: absolute;
    /* Posiciona el botón relativo al contenedor */
    top: 50%;
    /* A mitad del contenedor */
    left: 50%;
    /* A mitad del contenedor */
    transform: translate(-50%, -50%);
    /* Centra el botón exactamente */
}

.instructivo-img-original {
    display: block;
    margin: 0 auto;
    max-width: none !important;
    width: auto !important;
    height: auto !important;
}
</style>